module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/Paywall-dbc05088be1448a3c9994f1d9554eca2.png";